"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instance = instance;

var services = _interopRequireWildcard(require("../services"));

var _constants = require("./constants");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var STORE = new Map();

var setLocale = function setLocale(localeCode) {
  STORE.set(_constants.LOCALE, localeCode);
};

var setValues = function setValues(values, localeCode) {
  localeCode && setLocale(localeCode);
  var locale = getLocale();
  var items = services.mapValues(values);
  STORE.set(locale, items);
};

var setDefaultValues = function setDefaultValues(values) {
  var items = services.mapValues(values);
  STORE.set(_constants.DEFAULT, items);
};

var getValue = function getValue(key, params, cb) {
  var value = getValueByKey(key);

  if (value) {
    var interpolate = typeof cb === 'function' && cb || services.interpolate;
    return interpolate(value, params);
  }

  console.warn("i18n-smart: undefined key '".concat(key, "'"));
  return key;
};

var getValueByKey = function getValueByKey(key) {
  var translations = getTranslations();
  var defaultTranslations = getDefaultTranslations();
  return translations.get(key) || defaultTranslations.get(key);
};

var getDefaultTranslations = function getDefaultTranslations() {
  return STORE.get(_constants.DEFAULT) || new Map();
};

var getTranslations = function getTranslations(localeCode) {
  var locale = localeCode || getLocale();
  return STORE.get(locale) || new Map();
};

var getValues = function getValues() {
  return services.unmapValues(STORE);
};

var getLocale = function getLocale() {
  return STORE.get(_constants.LOCALE) || console.warn('i18n-smart: `locale` has not been initialized');
};

var hasTranslations = function hasTranslations(localeCode) {
  return Boolean(STORE.get(localeCode));
};

var hasValue = function hasValue(key) {
  return Boolean(getValueByKey(key));
};

var clear = function clear() {
  STORE.clear();
};

var interfaces = {
  value: getValue,
  interpolate: getValue,
  pluralize: function pluralize(key, options) {}
};

function instance() {
  return _objectSpread({
    setDefaultValues: setDefaultValues,
    setValues: setValues,
    setLocale: setLocale,
    getValue: getValue,
    getValues: getValues,
    getLocale: getLocale,
    getValueByKey: getValueByKey,
    hasTranslations: hasTranslations,
    hasValue: hasValue,
    clear: clear
  }, interfaces);
}